import {reduxForm, Field, isDirty} from 'redux-form'
import styles from './PermissionForm.css'
import DescriptiveSwitchField from 'components/Fields/ReduxForm/DescriptiveSwitchField'
import {connect} from 'react-redux'

const validate = (values) => {
  const errors = {}

  if (!values.authCode) {
    // error if allowStaffRefund , staffDeleteBill, staffResendReceipt is not empty
    if (values.allowStaffRefund || values.staffDeleteBill || values.staffResendReceipt) {
      errors.authCode = 'This field is required'
    }
  } else if (values.authCode.length < 4) {
    errors.authCode = 'Please enter at least 4 characters'
  } else if (!/^[0-9]+$/.test(values.authCode)) {
    errors.authCode = 'Please enter a valid number'
  }

  return errors
}

const renderInput = (field) => {
  return (<div>
    <input {...field.input}
      placeholder={field.placeholder}
      className={field.className}
      maxLength={field.maxLength}
      type={field.type} />
    {field.meta.touched && field.meta.error && <label className='error'>{field.meta.error}</label>}
  </div>)
}

class PermissionForm extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showPassword: false
    }
  }

  showPasswordButton = () => {
    this.setState({showPassword: !this.state.showPassword})
  }

  render () {
    let {handleSubmit} = this.props
    return (<form onSubmit={handleSubmit}>
      <DescriptiveSwitchField
        label='Ask staff to enter authorization code to issue refund'
        sublabel=''
        name='allowStaffRefund'
      />
      <DescriptiveSwitchField
        label='Ask staff to enter authorization code to delete or modify bill'
        sublabel=''
        name='staffDeleteBill'
      />
      <DescriptiveSwitchField
        label='Ask staff to enter authorization code to resend / reprint receipt'
        sublabel=''
        name='staffResendReceipt'
      />
      <div className='row'>
        <div className={`col-lg-12 ${styles['authorization-code-wrapper']}`}>
          <p>Authorization Code</p>
          <div className={`col-md-4 no-padding`}>
            <Field
              name='authCode'
              component={renderInput}
              className='form-control'
              placeholder='4-digit PIN'
              maxLength='4'
              type={this.state.showPassword ? 'text' : 'password'}
            />
            <i type='button' onClick={this.showPasswordButton} className={`${styles['eye-button']} ${this.state.showPassword ? 'glyphicon glyphicon-eye-close' : 'glyphicon glyphicon-eye-open'}`} />
          </div>
        </div>
      </div>
      <p className={styles.description}>
        Employees will be able to take payments but will not be able to edit on the iPad.
        Employees will also not have access to the web back office.
      </p>

      <hr />
      <div className='row'>
        <div className='col-lg-12'>
          <button className='btn btn-primary pull-right'>Save</button>
        </div>
      </div>
    </form>)
  }
}

const mapForm = {
  form: 'permission',
  touchOnBlur: false,
  touchOnChange: true,
  validate
}

PermissionForm.propTypes = {
  onSubmit: React.PropTypes.func
}

function mapStateToProps (state) {
  return {
    isDirtyForm: isDirty('permission')(state)
  }
}

export default connect(mapStateToProps)(reduxForm(mapForm)(PermissionForm))



// WEBPACK FOOTER //
// ./app/pages/Employees/Permission/PermissionForm/PermissionForm.js